import { render, staticRenderFns } from "./UserPermissionAddAccess.vue?vue&type=template&id=0faceb2b&scoped=true"
import script from "./UserPermissionAddAccess.vue?vue&type=script&lang=js"
export * from "./UserPermissionAddAccess.vue?vue&type=script&lang=js"
import style0 from "./UserPermissionAddAccess.vue?vue&type=style&index=0&id=0faceb2b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0faceb2b",
  null
  
)

export default component.exports